import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Inject, Input, ContentChild, HostBinding, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MODE_PROVIDER } from '@taiga-ui/core/providers';
import { TUI_MODE } from '@taiga-ui/core/tokens';
import * as i1 from '@tinkoff/ng-polymorpheus';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import * as i2 from 'rxjs';
const _c0 = ["tuiLabel", ""];
const _c1 = ["*"];
function TuiLabelComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
  }
  if (rf & 2) {
    const text_r1 = ctx.polymorpheusOutlet;
    i0.ɵɵproperty("textContent", text_r1);
  }
}
class TuiLabelComponent {
  constructor(mode$) {
    this.mode$ = mode$;
    this.context = {
      $implicit: null
    };
  }
}
TuiLabelComponent.ɵfac = function TuiLabelComponent_Factory(t) {
  return new (t || TuiLabelComponent)(i0.ɵɵdirectiveInject(TUI_MODE));
};
TuiLabelComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: TuiLabelComponent,
  selectors: [["label", "tuiLabel", ""]],
  contentQueries: function TuiLabelComponent_ContentQueries(rf, ctx, dirIndex) {
    if (rf & 1) {
      i0.ɵɵcontentQuery(dirIndex, NgControl, 5);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.control = _t.first);
    }
  },
  hostVars: 2,
  hostBindings: function TuiLabelComponent_HostBindings(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵlistener("$.data-mode.attr", function TuiLabelComponent___data_mode_attr_HostBindingHandler() {
        return ctx.mode$;
      });
    }
    if (rf & 2) {
      i0.ɵɵclassProp("_control", ctx.control);
    }
  },
  inputs: {
    tuiLabel: "tuiLabel",
    context: "context"
  },
  features: [i0.ɵɵProvidersFeature([MODE_PROVIDER])],
  attrs: _c0,
  ngContentSelectors: _c1,
  decls: 4,
  vars: 2,
  consts: [[1, "t-label"], ["class", "t-text", 3, "textContent", 4, "polymorpheusOutlet", "polymorpheusOutletContext"], [1, "t-content"], [1, "t-text", 3, "textContent"]],
  template: function TuiLabelComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵelementStart(0, "span", 0);
      i0.ɵɵtemplate(1, TuiLabelComponent_span_1_Template, 1, 1, "span", 1);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(2, "span", 2);
      i0.ɵɵprojection(3);
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵadvance();
      i0.ɵɵproperty("polymorpheusOutlet", ctx.tuiLabel)("polymorpheusOutletContext", ctx.context);
    }
  },
  dependencies: [i1.PolymorpheusOutletDirective],
  styles: ["[_nghost-%COMP%]{display:flex;min-height:2.75rem;justify-content:space-between;flex-direction:column;pointer-events:none}.t-label[_ngcontent-%COMP%]{font:var(--tui-font-text-s);max-width:100%;align-self:inherit;overflow:inherit;pointer-events:auto}._control[_nghost-%COMP%]   .t-label[_ngcontent-%COMP%]{margin-bottom:.25rem}.t-text[_ngcontent-%COMP%]{display:block;overflow:inherit;text-overflow:ellipsis}[_nghost-%COMP%]:not(._control)   .t-text[_ngcontent-%COMP%]{color:var(--tui-text-02)}[data-mode=\"onDark\"][_nghost-%COMP%]   .t-text[_ngcontent-%COMP%]{color:var(--tui-text-02-night)}.t-content[_ngcontent-%COMP%]{line-height:1.5rem;overflow:inherit;text-overflow:ellipsis;pointer-events:auto;border-radius:inherit}"],
  changeDetection: 0
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TuiLabelComponent, [{
    type: Component,
    args: [{
      selector: 'label[tuiLabel]',
      templateUrl: './label.template.html',
      styleUrls: ['./label.style.less'],
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [MODE_PROVIDER],
      host: {
        '($.data-mode.attr)': 'mode$'
      }
    }]
  }], function () {
    return [{
      type: i2.Observable,
      decorators: [{
        type: Inject,
        args: [TUI_MODE]
      }]
    }];
  }, {
    tuiLabel: [{
      type: Input
    }],
    context: [{
      type: Input
    }],
    control: [{
      type: ContentChild,
      args: [NgControl]
    }, {
      type: HostBinding,
      args: ['class._control']
    }]
  });
})();
class TuiLabelModule {}
TuiLabelModule.ɵfac = function TuiLabelModule_Factory(t) {
  return new (t || TuiLabelModule)();
};
TuiLabelModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
  type: TuiLabelModule
});
TuiLabelModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
  imports: [[PolymorpheusModule]]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TuiLabelModule, [{
    type: NgModule,
    args: [{
      imports: [PolymorpheusModule],
      declarations: [TuiLabelComponent],
      exports: [TuiLabelComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiLabelComponent, TuiLabelModule };
